// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Calendar icon.
 * @param {IconProps} props - The IconProps for the CalendarIcon component.
 * @returns {ReactElement} The CalendarIcon component.
 */
export const CalendarIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='15px' height='18px' viewBox='0 0 15 18' color={color} {...rest} id='calendar'>
      <path
        d='M2.14286 8.83929C2.14286 8.09933 2.74252 7.5 3.48214 7.5H6.16071C6.90067 7.5 7.5 8.09933 7.5 8.83929V11.5179C7.5 12.2578 6.90067 12.8571 6.16071 12.8571H3.48214C2.74252 12.8571 2.14286 12.2578 2.14286 11.5179V8.83929ZM3.21429 8.83929V11.5179C3.21429 11.6652 3.33415 11.7857 3.48214 11.7857H6.16071C6.30804 11.7857 6.42857 11.6652 6.42857 11.5179V8.83929C6.42857 8.69196 6.30804 8.57143 6.16071 8.57143H3.48214C3.33415 8.57143 3.21429 8.69196 3.21429 8.83929ZM4.28571 2.14286H10.7143V0.535714C10.7143 0.239866 10.9554 0 11.25 0C11.5446 0 11.7857 0.239866 11.7857 0.535714V2.14286H12.8571C14.0391 2.14286 15 3.10212 15 4.28571V15C15 16.1819 14.0391 17.1429 12.8571 17.1429H2.14286C0.959263 17.1429 0 16.1819 0 15V4.28571C0 3.10212 0.959263 2.14286 2.14286 2.14286H3.21429V0.535714C3.21429 0.239866 3.45536 0 3.75 0C4.04464 0 4.28571 0.239866 4.28571 0.535714V2.14286ZM1.07143 15C1.07143 15.5926 1.55123 16.0714 2.14286 16.0714H12.8571C13.4498 16.0714 13.9286 15.5926 13.9286 15V6.42857H1.07143V15ZM1.07143 4.28571V5.35714H13.9286V4.28571C13.9286 3.69308 13.4498 3.21429 12.8571 3.21429H2.14286C1.55123 3.21429 1.07143 3.69308 1.07143 4.28571Z'
        fill='currentColor'
      />
    </Icon>
  );
};
